import type { ComponentProps, FC } from 'react';
import { forwardRef } from 'react';

import { StyledButton, StyledIcon } from './styled';

import type { IconName } from '../Icon';

export enum ButtonVariant {
    PRIMARY,
    SECONDARY,
    TERTIARY,
}

export enum ButtonSize {
    SMALL,
    MEDIUM,
    LARGE,
}

type IButton = ComponentProps<typeof StyledButton> & {
    iconName?: IconName;
    variant?: ButtonVariant;
    size?: ButtonSize;
    active?: boolean;
};

export const Button: FC<IButton> = forwardRef(
    ({ children, iconName, size, ...restProps }, ref) => (
        <StyledButton ref={ref} size={size} {...restProps}>
            {iconName !== undefined && (
                <StyledIcon size={size} iconName={iconName} />
            )}
            {children}
        </StyledButton>
    )
);

export const ButtonStyledIcon = StyledIcon;

Button.defaultProps = {
    iconName: undefined,
    variant: ButtonVariant.PRIMARY,
    size: ButtonSize.MEDIUM,
    active: false,
};
